
import { firstValueFrom } from 'rxjs'
import { createAppAsyncThunk } from 'store/state'
import { feedAdapter, streamAdapter } from 'services/content/util'
import { V1 } from './net'

export const getLatestSearches = createAppAsyncThunk(
  'search/getLatestSearches',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await firstValueFrom(dispatch(V1.getLatestSearches()))
      return response.searches.map((s: any) => s.term)
    } catch (e) {
      return rejectWithValue(e)
    }
  }
)

export const addLatestSearch = createAppAsyncThunk(
  'search/addLatestSearch',
  async (query: string, { dispatch, rejectWithValue }) => {
    try {
      await firstValueFrom(dispatch(V1.addLatestSearch(query)))

      return query
    } catch (e) {
      return rejectWithValue(e)
    }
  }
)

export const getRecentlyViewed = createAppAsyncThunk(
  'search/getRecentlyViewed',
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await firstValueFrom(dispatch(V1.getRecentlyViewed()))
      return response.recent.map(source => {
        if ((source as any).handle) {
          return feedAdapter(source as any)
        }
        return streamAdapter(source as any)
      })
    } catch (e) {
      return rejectWithValue(e)
    }
  }
)

export const addRecentlyViewed = createAppAsyncThunk(
  'search/addRecentlyViewed',
  async (args: {source: any, type: 'feed' | 'stream'}, { dispatch, rejectWithValue }) => {
    try {
      await firstValueFrom(dispatch(V1.addRecentlyViewed(args.source.id, args.type)))

      return args.source
    } catch (e) {
      return rejectWithValue(e)
    }
  }
)

export const deleteRecentSearch = createAppAsyncThunk(
  'search/deleteRecentSearch',
  async (term: string, { dispatch, rejectWithValue }) => {
    try {
      await firstValueFrom(dispatch(V1.deleteRecentSearch(term)))

      return term
    } catch (e) {
      return rejectWithValue(e)
    }
  }
)
